export const books = [
  {
    image:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1650844397l/60784591.jpg",
    title: "A Mystery of Mysteries: The Death and Life of Edgar Allan Poe",
    author: "Mark Dawidziak",
    desc: "A Mystery of Mysteries is a brilliant biography of Edgar Allan Poe that examines the renowned author’s life through the prism of his mysterious death and its many possible causes.It is a moment shrouded in horror and mystery. Edgar Allan Poe died on October 7, 1849, at just forty, in a painful, utterly bizarre manner that would not have been out of place in one of his own tales of terror.",
    genres: ["biography", "mystery"],
    rating: 4,
    myRate: null,
    "total-ratings": 120,
    status: null,
  },
  {
    image:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1674683455l/59366242.jpg",
    title:
      "The Hard Parts: From Chernobyl to Paralympic Champion—My Story of Achieving the Extraordinary",
    author: "Oksana Masters",
    desc: "From the author of Group, a New York Times bestseller and Reese’s Book Club Pick, comes a moving, heartwarming, and powerful memoir about Christie Tate’s lifelong struggle to sustain female friendship, and the friend who helps her find the human connection she seeks.",
    genres: ["biography", "cheerful"],
    rating: 4.5,
    myRate: 3,
    "total-ratings": 60,
    status: "completed",
  },
  {
    image:
      "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1673870622i/60784365.jpg",
    title: "Wolfish: Wolf, Self, and the Stories We Tell About Fear",
    author: "Erica Berry",
    desc: "An original and probing debut work of nonfiction by a brilliant new writer, rooted in her years-long quest to study the cultural legacy of the wolf In this enthralling, kaleidoscopic exploration of wolves both real and symbolic, Erica Berry weaves historic and scientific findings alongside criticism, journalism, and memoir to illuminate the strands of our cultural constructions of predator and prey, and what it means to navigate a world in which we can be both.",
    genres: ["study"],
    rating: 4.2,
    myRate: null,
    "total-ratings": 13,
    status: null,
  },
  {
    image:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1528206996l/38746485.jpg",
    title: "Becoming",
    author: "Michelle Obama",
    desc: "In a life filled with meaning and accomplishment, Michelle Obama has emerged as one of the most iconic and compelling women of our era.",
    genres: ["biography"],
    rating: 5,
    myRate: null,
    "total-ratings": 200,
    status: null,
  },
  {
    image:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1536184191l/41721428._SY475_.jpg",
    title: "Can't Hurt Me: Master Your Mind and Defy the Odds",
    author: "David Goggins",
    desc: "For David Goggins, childhood was a nightmare - poverty, prejudice, and physical abuse colored his days and haunted his nights. But through self-discipline, mental toughness, and hard work, Goggins transformed himself from a depressed, overweight young man with no future into a U.S. Armed Forces icon and one of the world's top endurance athletes.",
    genres: ["biography", "self-help"],
    rating: 5,
    myRate: null,
    "total-ratings": 200,
    status: "reading",
  },
  {
    image:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1626722248l/56269187.jpg",
    title: "Three Sisters (The Tattooist of Auschwitz, #3)",
    author: "Heather Morris",
    desc: "A promise to stay together. An unbreakable bond. A fierce will to survive. From international bestselling author Heather Morris comes the breathtaking conclusion to The Tattooist of Auschwitz trilogy.",
    genres: ["study"],
    rating: 4,
    myRate: null,
    "total-ratings": 200,
    status: null,
  },
  {
    image:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1595373758l/53239311._SY475_.jpg",
    title: "The Happiest Man on Earth",
    author: "Eddie Jaku",
    desc: "Life can be beautiful if you make it beautiful. It is up to you. Eddie Jaku always considered himself a German first, a Jew second. He was proud of his country. But all of that changed in November 1938, when he was beaten, arrested and taken to a concentration camp.",
    genres: ["study"],
    rating: 5,
    myRate: null,
    "total-ratings": 200,
    status: "to-read",
  },
  {
    image:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1663337614l/60880793._SY475_.jpg",
    title: "Good for a Girl: A Woman Running in a Man's World",
    author: "Lauren Fleshman",
    desc: "Fueled by her years as an elite runner and advocate for women in sports, Lauren Fleshman offers her inspiring personal story and a rallying cry for reform of a sports landscape that is failing young female athletes Lauren Fleshman has grown up in the world of running.",
    genres: ["study"],
    rating: 5,
    myRate: null,
    "total-ratings": 200,
    status: "to-read",
  },
  {
    image:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1672604176l/63212622._SY475_.jpg",
    title: "Movie Star: They Always Say They're Single",
    author: "Jessica Simpson",
    desc: "An untold true short story about the mid-2000s, a world-famous actor, and a fantasy Hollywood romance gone wrong by Jessica Simpson, the #1 New York Times bestselling author of Open Book. After the end of her marriage to the first man she ever loved, Jessica Simpson wonders who she really is.",
    genres: ["study"],
    rating: 5,
    myRate: null,
    "total-ratings": 200,
    status: null,
  },
  {
    image:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1675909158l/59345245._SY475_.jpg",
    title: "Bad Mormon: A Memoir",
    author: "Heather Gay",
    desc: "INSTANT NEW YORK TIMES BESTSELLER As seen in The New York Times , People , The Cut , Vulture , The Daily Beast , Today , Bustle , Us Weekly , Life & Style , and Interview Drinking and Tweeting meets Unorthodox in this vulnerable memoir about The Real Housewives of Salt Lake City star’s departure from the Mormon Church, and her unforeseen success in business, television, and single motherhood.",
    genres: ["study"],
    rating: 2.5,
    myRate: null,
    "total-ratings": 200,
    status: null,
  },
  {
    image:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1664755254l/61812427.jpg",
    title: "Love, Pamela",
    author: "Pamela Andersond",
    desc: "An imaginary book created to fill up as dummy data for bookclub schema",
    genres: ["study"],
    rating: 5,
    myRate: null,
    "total-ratings": 200,
    status: null,
  },
];
